import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../axios";
import { Loading } from "../../../Other/Loading";
const { REACT_APP_LOGIN_API_BASEURL } = process.env;

const PaymentReport = () => {
  const [paymentReport, setPaymentReport] = useState([]);
  useEffect(() => {
  const fetchMonthlyPaymentReport = async () => {
    try {
      const res = await axiosInstance.get(`${REACT_APP_LOGIN_API_BASEURL}/v2/monthly-payment-report`);
      setPaymentReport(res?.data?.data);
    } catch (error) {
      console.error("Error fetching monthly payment report:", error.message);
    }
  };

  fetchMonthlyPaymentReport();
}, []);

  return (
    <div className="width-0">
      <div className="dashboard-container-new">
        <p>Monthly Payment Report</p>
        <div>
          <button className="lastmonth-btn">Last Month</button>
          <button className="export-btn">Export</button>
        </div>
      </div>

      <div className="instructor-table">
        {paymentReport.length === 0 ? (
          <Loading />
        ) : (
          <table className="table-width-100">
            <thead>
              <tr>
                <th>S.no</th>
                <th>Month</th>
                <th>Students Purchased</th>
                <th>Courses Sold</th>
                <th>Bundles Sold</th>
                <th>totalOrders</th>
                <th>BundleSales In INR</th>
                <th>BundleSales In USD</th>
                <th>CourseSales In INR</th>
                <th>CourseSales In USD</th>
              </tr>
            </thead>
            <tbody>
              {paymentReport.map((ele, index) => {
                return (
                  <tr key={index}>
                    <td className="cell">{1 + index}</td>
                    <td className="cell">{ele?.Month?ele?.Month:"-"}</td>
                    <td className="cell">{ele?.StudentsPurchased?ele?.StudentsPurchased:"-"}</td>
                    <td className="cell">{ele?.CoursesSold?ele?.CoursesSold:"-"}</td>
                    <td className="cell">{ele.BundlesSold?ele.BundlesSold:"-"}</td>
                    <td className="cell">{ele?.totalOrders?ele?.totalOrders:"-"}</td>
                    <td className="cell">{ele?.BundleSalesInINR?ele?.BundleSalesInINR:"-"}</td>
                    <td className="cell">{ele?.BundleSalesInUSD?ele?.BundleSalesInUSD:"-"}</td>
                    <td className="cell">{ele?.CourseSalesInINR?ele?.CourseSalesInINR:"-"}</td>
                    <td className="cell">{ele?.CourseSalesInUSD?ele?.CourseSalesInUSD:"-"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default PaymentReport;
